/**
 * @deprecated не используйте эту функцию напрямую, используйте RootThemeProvider
 * @internal
 */
export function addRootTheme(themeClasses: string, root?: HTMLElement) {
    if (typeof document === 'undefined') {
        return;
    }
    if (!root) {
        root = document.body;
    }

    const classList = Array.from(root.classList);

    classList.forEach(token => {
        if (token.startsWith('dc-Theme')) {
            root.classList.remove(token);
        }
    });

    const classes = themeClasses.split(' ');
    root.classList.add(...classes);
}
